import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import "./styles/tokens.css";
import "./styles/theme.css";
import "./styles/utilities.css";
import "./styles/globals.css";
import './index.css';
// import the PD override LAST so it wins specificity/order
import "./styles/pd.css";
import App from './App';
import { env } from './lib/env';

// Environment debugging
// eslint-disable-next-line no-console
console.log("[ENV]", {
  API_BASE_URL: env.API_BASE_URL,
  MODE: env.MODE,
  BASE_URL: env.BASE_URL,
  USE_MOCK: env.USE_MOCK,
});
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
